import React from "react";
import { EyeOff } from "lucide-react";

/**
 * Live / Off switch used for website pages, product pages and blog articles.
 * Off takes the page off the public site but keeps all of its content.
 */
export const LiveSwitch = ({ live, onChange, disabled = false, testId, previewHref = "" }) => (
    <div className="flex items-center gap-2">
        <button type="button" disabled={disabled} data-testid={testId}
            onClick={() => onChange(!live)}
            title={live ? "Live on the website — click to switch it off"
                : "Switched off — click to put it back live"}
            className={`relative h-5 w-10 shrink-0 border transition-colors ${
                live ? "border-lime/60 bg-lime/20" : "border-white/15 bg-white/5"
            } ${disabled ? "opacity-40 cursor-not-allowed" : "hover:border-gold/60"}`}>
            <span className={`absolute top-[3px] h-3 w-3 transition-all ${
                live ? "left-[24px] bg-lime" : "left-[3px] bg-zinc-500"}`} />
        </button>
        <span className={`mono text-[9px] tracking-[0.16em] ${live ? "text-lime" : "text-zinc-500"}`}
            data-testid={testId ? `${testId}-label` : undefined}>
            {live ? "LIVE" : "OFF"}
        </span>
        {!live && previewHref && (
            <a href={`${previewHref}?off_preview=1`} target="_blank" rel="noreferrer"
                title="Staff preview of the switched-off page"
                data-testid={testId ? `${testId}-preview` : undefined}
                className="text-zinc-500 hover:text-gold transition-colors">
                <EyeOff className="w-3.5 h-3.5" />
            </a>
        )}
    </div>
);

export default LiveSwitch;
